import { injectable } from 'inversify';
import { MultipartUploadAdapter } from '@dealroadshow/file-uploader';
import urls from '@drs/url';

@injectable()
export default class UploadAdapter extends MultipartUploadAdapter {
  constructor() {
    super({ url: urls.getBaseFilesUrl() });
  }
}
